module.exports = __webpack_public_path__ + "static/media/socra.95687ef2.png";